import React, { useState } from "react";
import "./hero.css";
import Signin from "../../components/auth/Signin";
import Reset from "../../components/auth/Reset";
import Logo from "../../img/UBEC-logo.png";

const Hero = ({ history }) => {
	const [authType, setAuthType] = useState(false);

	return (
		<div className="hero__page">
			<div className="hero__container">
				<div className="hero__left">
					<div className="logo">
						<img src={Logo} alt="logo" width="200" height="200" />
					</div>
					<h1>UBEC WORKFLOW DESK</h1>
					<p>Managing your processes in a more structured and organized method.</p>
					<div className="hero__cta__btns">
						<button className="cta__btn1">TETFUND</button>
						<button className="cta__btn2">MIN. OF EDUCATION</button>
					</div>
				</div>
				<div className="hero__right">
					{authType ? (
						<Reset handleChange={() => setAuthType(false)} />
					) : (
						<Signin handleChange={() => setAuthType(true)} history={history} />
					)}
				</div>
			</div>
			<div className="hero__slogan">
				"Education for all is the responsibility of all"
			</div>
		</div>
	);
};

export default Hero;
